// import { login as loginService } from "../services/api";
import { LOGIN_USER, LOGOUT_USER } from "./types";
import { get_auth_cookie, remove_auth_cookie } from "../../../helpers/auth";

export default {
  namespaced: true,
  state: {
    authenticated: false
  },
  mutations: {
    [LOGIN_USER](state) {
      state.authenticated = true;
    },
    [LOGOUT_USER](state) {
      state.authenticated = false;
    }
  },
  actions: {
    // async login({ commit }, credentials) {
    //   let data = await loginService(credentials);
    //   localStorage.setItem("token", data.access_token);
    //   localStorage.setItem("refresh", data.refresh_token);
    //   commit(LOGIN_USER);
    // },
    logout({ commit }) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      remove_auth_cookie();
      commit(LOGOUT_USER);
    },
    checkAuthenticated({ commit }) {
      var token = get_auth_cookie();
      if (token){
        commit(LOGIN_USER);
      }
    }
  }
};
